import { HTTP_STATUS_CODES } from "./HttpConstants";
import { ROUTES } from "./RouteConstants";

export const DEFAULT_USER_JOINED = "No one has joined the interview yet.";

export const SINGLE_USER_JOINED = " has joined the interview.";

export const MULTIPLE_USER_JOINED = " have joined the interview.";

export const INTERVIEWER_SETUP_MESSAGE = "Select Question Type";

export const CANDIDATE_WAIT_MESSAGE = "Interviewer is yet to set up a question";

export const GET_INTERVIEW_META_API_HTTP_STATUS_CODES = [
  404, 422, 500, 502, 503, 504,
];

export const GET_INTERVIEW_DETAILS_API_HTTP_STATUS_CODES = [
  403, 404, 422, 500, 503, 504,
];

export const GET_INTERVIEW_META_ERROR_MESSAGE =
  "Error in getting interview meta";

export const GET_INTERVIEW_DETAILS_ERROR_MESSAGE =
  "Error in getting interview details";

export const DO_SCHEDULE_CHECK_API_HTTP_STATUS_CODES = [
  400, 401, 403, 404, 422, 500, 503, 504,
];

export const DO_SCHEDULE_CHECK_ERROR_MESSAGE =
  "Error in schedule validation, please try again.";

export const GET_PLATFORM_META_ERROR = {
  defaultErrorMessage: "Error in getting platform details, please try again",
  expectedErrorCodes: [HTTP_STATUS_CODES.UNAUTHORIZED],
};

export const SSO_AUTH_VALIDATION_ERROR = {
  defaultErrorMessage: "",
  expectedErrorCodes: [HTTP_STATUS_CODES.UNAUTHORIZED],
  redirectionStates: {
    [HTTP_STATUS_CODES.UNAUTHORIZED]: {
      url: window.location.origin + ROUTES.NOT_FOUND_ROUTE,
      redirect: true,
    },
  },
};

export const ACCESS_TOKEN_AUTH_VALIDATION_ERROR = {
  defaultErrorMessage: "",
  expectedErrorCodes: [HTTP_STATUS_CODES.UNAUTHORIZED],
  redirectionStates: {
    [HTTP_STATUS_CODES.UNAUTHORIZED]: {
      url: window.location.origin + ROUTES.NOT_FOUND_ROUTE,
      redirect: true,
    },
  },
};

export const ACCESS_TOKEN_AUTH_ERROR_PAGE = {
  title: "Feedback Revision Link Inaccessible",
  description:
    "Looks like, this Feedback Revision link expired. Please get in touch with your point of contact for more information. \n \n Thank You!",
};
